import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../services/crud/users.service';
import { MultiCrudDataSource } from '../../../table-datasouces/multi-crud.datasource';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DateFormats } from '../../../providers/app-date-adapter';
import { AppUser } from '../../../dto/app-user';
import { RoleService } from '../../../services/role.service';
import { DateTableFilter } from '../../../table-datasouces/date-table-filter';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  users: AppUser[];
  dataSource = new MultiCrudDataSource(this.appUserService);
  columns = [
    { columnDef: 'email', header: 'Email', cellColor: (row: AppUser) => `${row.active ? 'black':'red'}`, cell: (row: AppUser) => `${row.email}`, sortable: true },
    { columnDef: 'active', header: 'Active', cellColor: (row: AppUser) => `${row.active ? 'forestgreen':'grey'}`, icon: (row: AppUser) => `${row.active ? 'check_box':'check_box_outline_blank'}`, cell: (row: AppUser) => '', sortable: false },
    { columnDef: 'firstName', header: 'First name', cellColor: (row: AppUser) => `${row.active ? 'black':'red'}`, cell: (row: AppUser) => `${row.firstName || '-'}`, sortable: true },
    { columnDef: 'lastName', header: 'Last name', cellColor: (row: AppUser) => `${row.active ? 'black':'red'}`, cell: (row: AppUser) => `${row.lastName || '-'}`, sortable: true },
    { columnDef: 'phoneNumber', header: 'Phone number', cell: (row: AppUser) => `${row.phoneNumber || '-'}`, sortable: true},
    { columnDef: 'roleGroup', header: 'Role group',
      icon: (row: AppUser) => {
        if ( row.roleGroup == 'admin') {
return 'stars';
}
        if ( row.roleGroup == 'manager') {
return 'star_half';
}
        if ( row.roleGroup == 'finance' || row.roleGroup == 'finance_manager') {
return 'money';
}
        if ( row.roleGroup == 'compliance' || row.roleGroup == 'compliance_manager') {
return 'bar_chart';
}
        if ( row.roleGroup == 'agent') {
return 'headset';
}
        if ( row.roleGroup == 'wallet') {
return 'format_list_bulleted';
}
        if ( row.roleGroup == 'collection_external') {
return 'my_location';
}
        if ( row.roleGroup == 'partner') {
return 'supervisor_account';
}
        if ( row.roleGroup == 'partner_support') {
return 'perm_identity';
}
        if ( row.roleGroup == 'marketing') {
return 'share';
}
        if ( row.roleGroup == 'issuer') {
return 'business_center';
}
      },
      iconColor: (row: AppUser) => {
        if ( row.roleGroup == 'admin') {
return 'blue';
}
      },
      cell: (row: AppUser) => {
        if ( row.roleGroup == 'admin') {
return 'Admin';
}
        if ( row.roleGroup == 'compliance_manager') {
return 'Compliance Manager';
}
        if ( row.roleGroup == 'compliance') {
return 'Compliance';
}
        if ( row.roleGroup == 'agent') {
return 'Agent';
}
        if ( row.roleGroup == 'partner_support') {
return 'Partner Support';
}
        if ( row.roleGroup == 'partner') {
return 'Partner';
}
        if ( row.roleGroup == 'finance_manager') {
return 'Finance Manager';
}
        if ( row.roleGroup == 'finance') {
return 'Finance';
}
        if ( row.roleGroup == 'manager') {
return 'Manager';
}
        if ( row.roleGroup == 'marketing') {
return 'Marketing';
}
        if ( row.roleGroup == 'wallet') {
return 'Wallet';
}


        return `${row.roleGroup || '-'}`;
      }, sortable: false
    } as ContentRowField<AppUser>,
    { columnDef: 'isTotpActive', header: '2FA', icon: (row: AppUser) => 'security', cellColor: (row: AppUser) => row.isTotpActive ? 'forestgreen':'orange', cell: (row: AppUser) => '', sortable: false },
  ] as ContentRowField<AppUser>[];

  constructor(
    private appUserService: UsersService,
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
  }

  getEditLink = (item: AppUser): string => item.id.toString();
}
